import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { AlertChatLogComponent } from './alert-chat-log/alert-chat-log.component';
import { AlertLogComponent } from './alert-log.component';

const routes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                component: AlertLogComponent,
                canActivate: [AuthGuard]
            }, {
                path: 'alertLog/:alertId',
                data: {
                    breadcrumb: 'activity'
                },
                children: [
                    {
                        path: '',
                        component: AlertLogComponent,
                        canActivate: [AuthGuard]
                    },
                    {
                        path: 'chat',
                        data: {
                            breadcrumb: 'chat'
                        },
                        children: [
                            {
                                path: '',
                                component: AlertChatLogComponent,
                                canActivate: [AuthGuard]
                            }
                        ]
                    }
                ]
            }
        ]
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AlertLogRoutingModule { }